import {
  Component,
  OnInit,
  Input,
  Output,
  ViewChild,
  TemplateRef,
  EventEmitter,
  ViewEncapsulation,
} from "@angular/core";
import {
  faPlus,
  faCheck,
  faExclamationTriangle,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { WatchlistService } from "../watchlist.service";
import { Observable } from "rxjs";
import { WatchlistResponse } from "../watchlist.model";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";

@Component({
  selector: "app-watchlist-menu",
  templateUrl: "./watchlist-menu.component.html",
  styleUrls: ["./watchlist-menu.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class WatchlistMenuComponent implements OnInit {
  @Input() ticker: string;
  @Output() onOpenWatchlistModal: EventEmitter<any> = new EventEmitter();
  faPlus = faPlus;
  faCheck = faCheck;
  faExclamationTriangle = faExclamationTriangle;
  faTimes = faTimes;
  watchLists = [];
  isVisibleWatchlistModal = false;
  dataObservable: Observable<WatchlistResponse>;
  message = "";
  _snackRef: MatSnackBarRef<any>;

  @ViewChild("successTemplate") successTemplate: TemplateRef<any>;
  @ViewChild("failureTemplate") failureTemplate: TemplateRef<any>;

  constructor(
    private dataService: WatchlistService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit() {
    this.dataObservable = this.dataService.getWatchlistsForTicker(this.ticker);
  }

  updateWatchlist(checked: boolean, item) {
    const watchlist = {
      watchername: item.w_name,
      watcherid: item.w_id,
      ticker: this.ticker,
      action: checked ? "add" : "delete",
    };
    this.dataService.updateWatchlist(watchlist).subscribe(
      (success: any) => {
        if (success.status && success.status === "failure") {
          console.error(success.msg);
          item.ticker_in_w = !checked;
          this.message = `Could not ${checked ? "add" : "remove"} ${
            this.ticker
          } ${checked ? "to" : "from"} ${item.w_name}`;
          this._snackRef = this.snackBar.openFromTemplate(
            this.failureTemplate,
            {
              panelClass: "failure",
              horizontalPosition: "center",
              verticalPosition: "top",
              duration: 5000,
            },
          );
        } else {
          this.message = `${checked ? "Added" : "Removed"} ${this.ticker} ${
            checked ? "to" : "from"
          } ${item.w_name}`;
          this._snackRef = this.snackBar.openFromTemplate(
            this.successTemplate,
            {
              panelClass: "success",
              horizontalPosition: "center",
              verticalPosition: "top",
              duration: 5000,
            },
          );
        }
      },
      (err) => {
        console.error(err);
        item.ticker_in_w = !checked;
      },
    );
  }

  openWatchlistModal() {
    // this.isVisibleWatchlistModal = true;
    this.onOpenWatchlistModal.emit();
  }

  onCloseWatchlistModal() {
    this.isVisibleWatchlistModal = false;
    this.dataObservable = this.dataService.getWatchlistsForTicker(this.ticker);
  }

  onWatchlisttDataResolved(watchlistData: WatchlistResponse) {
    this.watchLists = watchlistData.data;
  }

  dimissSnackBar() {
    this._snackRef.dismiss();
  }
}
